import Organization from "./Organization";
import {ResourceOwnerType} from "./ResourceOwnerType";

class ItemUpdateProfile {
    constructor(
        public id?: string,
        public name?: string,
        public description?: string,
        public query?: string,
        public owner?: ResourceOwnerType,
        public organization?: Organization) {
        //
    }

    public static fromPOJO(data: any) {
        if (!data) {
            return null;
        }

        const profile = new ItemUpdateProfile();

        profile.id = data.id;
        profile.name = data.name;
        profile.description = data.description;
        profile.query = data.query;
        profile.owner = data.owner;
        profile.organization = Organization.fromPOJO(data.organization);

        return profile;
    }
}

export function itemUpdateProfileSystemLastComparator(a: ItemUpdateProfile, b: ItemUpdateProfile) {
    if (a.owner === ResourceOwnerType.ORGANIZATION && b.owner === ResourceOwnerType.ORGANIZATION) {
        return 0;
    }

    if (a.owner === ResourceOwnerType.ORGANIZATION && b.owner === ResourceOwnerType.SYSTEM) {
        return -1;
    }

    if (a.owner === ResourceOwnerType.SYSTEM && b.owner === ResourceOwnerType.ORGANIZATION) {
        return 1;
    }

    return a.name.localeCompare(b.name);
}

export default ItemUpdateProfile;
